module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = 6
// module chunks = 0